export const elementIsVisibleInViewport = (el: HTMLElement, partiallyVisible = false, offset = 0): boolean => {
  if (!el || !(el instanceof Element)) return false;

  const { top, left, bottom, right } = el.getBoundingClientRect();
  const { clientHeight, clientWidth } = document.documentElement;

  if (partiallyVisible) {
    return (
      ((top - offset > 0 && top - offset < clientHeight) || (bottom + offset > 0 && bottom + offset < clientHeight)) &&
      ((left - offset > 0 && left - offset < clientWidth) || (right + offset > 0 && right + offset < clientWidth))
    );
  }

  return top - offset >= 0 && left - offset >= 0 && bottom + offset <= clientHeight && right + offset <= clientWidth;
};
